import type { HTMLAttributes, ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-sm border px-2 py-0.5 text-xs font-medium whitespace-nowrap',
  {
    variants: {
      variant: {
        neutral: 'border-border bg-surface-muted text-muted',
        info: 'border-signal/20 bg-signal/10 text-signal-strong',
        success: 'border-success/30 bg-success/10 text-healthy',
        warning: 'border-warning/30 bg-warning/10 text-degraded',
        error: 'border-error/30 bg-error/10 text-critical',
        pending: 'border-warning/30 bg-warning/10 text-degraded',
      },
    },
    defaultVariants: { variant: 'neutral' },
  },
);

type BadgeVariants = VariantProps<typeof badgeVariants>;

interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, BadgeVariants {
  children: ReactNode;
}

export function Badge({ variant, className, children, ...rest }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...rest}>
      {children}
    </span>
  );
}
